import { useI18n } from './I18nContext';

export function ModulePlaceholder({ title }: { title: string }) {
  const { t } = useI18n();
  return (
    <section className="metal-card placeholder-module">
      <p className="eyebrow">ELITE COACH CLOUD 2.0</p>
      <h1>{title}</h1>
      <p>{t.noData}</p>
      <p className="muted">This module will be migrated from the current app in the next implementation sprint.</p>
    </section>
  );
}
